import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export function markAllAsTouched(x: AbstractControl, onlySelf = false) {
  if (x instanceof UntypedFormGroup) {
    for (const name of Object.keys(x.controls)) {
      markAllAsTouched(x.controls[name], true);
    }
  } else if (x instanceof UntypedFormArray) {
    for (const c of x.controls) {
      markAllAsTouched(c, true);
    }
  }
  x.markAsTouched({ onlySelf });
}
